var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){$event.preventDefault();return _vm.routeTo($event)}}},[_c('router-link',{attrs:{"to":{},"exact":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }